module.exports = __webpack_public_path__ + "img/client26.b89fd501.svg";